import React from 'react';
import PropTypes from 'prop-types';
import { settingsByTab, getIsValidTimePeriod } from '../helpers/dashboard';
import { getDashboardChartOptions, getPdfDashboardChartOptions } from '../helpers/chart';
import { getBeginAndEndPeriodsData } from '../helpers/helpers';
import { useSearchStore } from '../../store/store';
import Card from './Card';
import { usePDFStore } from '../../store/pdf/store';
import { tabNames } from '../constants/listingViews/overview';

const Dashboard = ({ chartData, currentTab }) => {

    const {
        isPDFLoading,
    } = usePDFStore((state) => ({
        isPDFLoading: state.downloadModalStatus.isPDFLoading,
    }));

    const timePeriod = useSearchStore(state => state[state.selectedModule].loadedSearchCriteria?.timePeriod?.intervalType);
    const isInventory= currentTab.title === tabNames.inventory;

    const dashboardData = chartData?.length && getBeginAndEndPeriodsData(chartData);
    const currentTabSettings = settingsByTab[currentTab.title];
    const revisedCardsSettings = currentTabSettings?.cards.filter(card => card?.timePeriods
        ? getIsValidTimePeriod(timePeriod, card.timePeriods)
        : true
    );

    const cards = dashboardData && revisedCardsSettings?.map(card => {
        const chartProps = getDashboardChartOptions(dashboardData, card, timePeriod);
        return <Card
                    card={card}
                    chartProps={chartProps}
                    dashboardData={dashboardData}
                    key={card.title}
                    isPDF={false}
                />
    });

    const pdfCards = dashboardData && revisedCardsSettings?.map(card => {
        const chartProps = getPdfDashboardChartOptions(dashboardData, card, timePeriod, isInventory);
        return <Card
                    card={card}
                    chartProps={chartProps}
                    dashboardData={dashboardData}
                    key={card.title}
                    isPDF={true}
                />
    });

    return (
        <>
            <div className={`dashboard-wrapper ${currentTabSettings.gridClass} mb-3`}>
                {cards}
            </div>
            {isPDFLoading && <div className={`dashboard-capture-area ${currentTabSettings.gridClass} mb-3`}>
                {pdfCards}
            </div>
            }
        </>
    );
};

Dashboard.propTypes = {
    chartData: PropTypes.array,
    currentTab: PropTypes.object
};

export default Dashboard;
